export const environment = {
    url: "https://api-tts.policystreet.app/api",
    siteKey: "6Ldc9SUtAAAAABSnQJ6mjW4qbw-W5PqDNZEssCiw", // Recaptcha 'fruit-claim-web' key id
};
